import { defineComponent, ref, onMounted, openBlock, createElementBlock, normalizeStyle } from "vue";
import { Application } from "@splinetool/runtime";
const _hoisted_1 = ["id"];
const _sfc_main = defineComponent({
  __name: "vue3-spline",
  props: {
    canvasId: {
      type: String,
      default: "spline-canvas"
    },
    scene: {
      type: Object,
      required: true
    },
    canvasStyle: {
      type: Object,
      default: () => ({ height: "100%", width: "100%", outline: "none" })
    }
  },
  emits: ["loaded", "error"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const canvasRef = ref(null);
    const splineInstance = ref(null);
    const emit = __emit;
    onMounted(() => {
      if (canvasRef.value) {
        splineInstance.value = new Application(canvasRef.value);
        splineInstance.value.load(props.scene.url, props.scene.variables).then(() => emit("loaded")).catch((error) => emit("error", error));
      }
    });
    const play = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.play();
    };
    const pause = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.stop();
    };
    const setVariables = (variables) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.setVariables(variables);
    };
    const setVariable = (name, value) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.setVariable(name, value);
    };
    const getVariables = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.getVariables();
    };
    const getVariable = (name) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.getVariable(name);
    };
    const stop = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.stop();
    };
    const setBackgroundColor = (color) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.setBackgroundColor(color);
    };
    const getAllObjects = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.getAllObjects();
    };
    const getSplineEvents = () => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.getSplineEvents();
    };
    const setZoom = (zoom) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.setZoom(zoom);
    };
    const setSize = (width, height) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.setSize(width, height);
    };
    const findObjectById = (uuid) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.findObjectById(uuid);
    };
    const findObjectByName = (name) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.findObjectByName(name);
    };
    const emitEvent = (eventName, nameOrUuid) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.emitEvent(eventName, nameOrUuid);
    };
    const emitEventReverse = (eventName, nameOrUuid) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.emitEventReverse(eventName, nameOrUuid);
    };
    const addEventListener = (eventName, cb) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.addEventListener(eventName, cb);
    };
    const removeEventListener = (eventName, cb) => {
      var _a;
      return (_a = splineInstance.value) == null ? void 0 : _a.removeEventListener(eventName, cb);
    };
    const spline = splineInstance;
    __expose({
      spline,
      play,
      pause,
      stop,
      setVariables,
      setVariable,
      getVariables,
      getVariable,
      setBackgroundColor,
      getAllObjects,
      getSplineEvents,
      setZoom,
      setSize,
      findObjectById,
      findObjectByName,
      emitEvent,
      emitEventReverse,
      addEventListener,
      removeEventListener
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: normalizeStyle(__props.canvasStyle),
        id: __props.canvasId
      }, null, 12, _hoisted_1);
    };
  }
});
var index = {
  install(app, options) {
    var _a;
    const name = (_a = options == null ? void 0 : options.name) != null ? _a : "Vue3Spline";
    app.component(name, _sfc_main);
  }
};
export { _sfc_main as Vue3Spline, index as default };
